export default __webpack_public_path__ + "static/media/trr-food-pastry-10.06580e70.png";